import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const images = Array.from(
  { length: 16 },
  (_, i) => `/assets/bcimages/bchome/bc-home-slider/${i + 1}.png`
);

const BcHomeSlider = () => {
  return (
    <div className="slider-container">
      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1}
        spaceBetween={20}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        pagination={{
          clickable: true,
          el: ".custom-pagination",
          renderBullet: (index, className) => `
            <span class="${className}">
              <span class="progress-line"></span>
            </span>
          `,
        }}
        breakpoints={{
          100: { slidesPerView: 1, spaceBetween: 10 },
          800: { slidesPerView: 2, spaceBetween: 15 },
          1500: { slidesPerView: 3, spaceBetween: 20 },
        }}
      >
        {images.map((src, index) => (
          <SwiperSlide key={index} className="slide-item">
            <img
              src={src}
              alt={`Slide ${index + 1}`}
              className="slider-image"
              style={{
                borderRadius: "20px",
                objectFit: "cover",
                objectPosition: "center top",
                height: "calc(100% - 20px)", // Crops 2px from bottom
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div style={{ margin: "10px" }} className="custom-pagination"></div>
    </div>
  );
};

export default BcHomeSlider;
